export const FILTER_PARAM_KEY = 'filter';
export const GROUP_PARAM_KEY = 'group';
export const SORT_PARAM_KEY = 'sort';
export const TYPE_PARAM_KEY = 'type';

export const DEFAULT_FILTER_PARAM_VALUE = 'all';
export const DEFAULT_GROUP_PARAM_VALUE = 'all';
export const DEFAULT_SORT_PARAM_VALUE = 'none';
export const DEFAULT_TYPE_PARAM_VALUE = 'all';

export const getUrlSearchParams = (): URLSearchParams =>
    new URL(window.location.href).searchParams;

type ParamUpdates = Partial<Record<string, string>>;

export const updateUrlParams = (updates: ParamUpdates, hasGroups?: boolean) => {
    const url = new URL(window.location.href);

    // Remove filter param when in group mode
    if (hasGroups === true) {
        url.searchParams.delete(FILTER_PARAM_KEY);
    }

    // Remove group param when in legacy mode
    if (hasGroups === false) {
        url.searchParams.delete(GROUP_PARAM_KEY);
    }

    Object.entries(updates).forEach(([key, value]) => {
        if (value !== undefined) {
            // Delete param if it matches the default value
            const defaultValues: Record<string, string> = {
                [TYPE_PARAM_KEY]: DEFAULT_TYPE_PARAM_VALUE,
                [SORT_PARAM_KEY]: DEFAULT_SORT_PARAM_VALUE,
                [GROUP_PARAM_KEY]: DEFAULT_GROUP_PARAM_VALUE,
                [FILTER_PARAM_KEY]: DEFAULT_FILTER_PARAM_VALUE,
            };

            if (defaultValues[key] === value) {
                url.searchParams.delete(key);
            } else {
                url.searchParams.set(key, value);
            }
        }
    });

    window.history.replaceState(
        {},
        '',
        `${url.pathname}${url.search}${url.hash}`
    );
};
